<div class="select">
    <div
        class="select-input"
        [ngClass]="{
            'select-input-opened': optionsVisible,
            'no-border': noBorder,
            disabled: disabled,
        }"
        (click)="inputOnClick()">
        <div class="select-input-value" *ngIf="selectedIndex !== -1">
            <img *ngIf="options[selectedIndex].iconPath" [src]="options[selectedIndex].iconPath" class="option-img" />
            <div class="select-input-value-text" appLongTextTooltip>
                {{
                    useLabelProviderPipe
                        ? (options[selectedIndex].displayName | labelsProvider)
                        : useBeutifyStringProviderPipe
                          ? (options[selectedIndex].displayName | beautifyDisplayString)
                          : options[selectedIndex].displayName
                }}
            </div>
        </div>
        <div class="select-input-placeholder" *ngIf="selectedIndex === -1">
            {{ placeHolder }}
        </div>
        <img src="assets/images/arrows/empty-arrow-down.svg" class="drop-down" alt="expand" />
    </div>
    <div class="select-options" *ngIf="optionsVisible" (clickOutside)="optionsVisible = false" [delayClickOutsideInit]="true">
        <div
            *ngFor="let option of options; index as i"
            class="select-option"
            [ngClass]="{
                'select-option-selected': selectedIndex === i,
                'select-option-disabled': option.disabled,
            }"
            (click)="onSelect(i); $event.stopPropagation()"
            [matTooltip]="option.tooltip ? option.tooltip : ''"
            matTooltipPosition="left"
            matTooltipClass="tooltip-container">
            <img *ngIf="option.iconPath" [src]="option.iconPath" class="option-img" />
            <div class="option-text" appLongTextTooltip>
                {{
                    useLabelProviderPipe
                        ? (option.displayName | labelsProvider)
                        : useBeutifyStringProviderPipe
                          ? (option.displayName | beautifyDisplayString)
                          : option.displayName
                }}
            </div>
        </div>
    </div>
</div>
